<div [formGroup]="group" class="inner-chart-embedded">
  <app-inner-chart-embedded [formControlName]="config.name"
                            [id]="uniqueComponentId('chartembedded-')"
                            [config]="config"
                            [group]="group">
  </app-inner-chart-embedded>
</div>
